export const hapticFeedback = () => {
  const supportVibrate = 'vibrate' in window.navigator;
  if (supportVibrate) {
    window.navigator.vibrate(100);
  } else {
    const triggerLabel = document.createElement('label');
    triggerLabel.setAttribute('aria-hidden', 'true');
    triggerLabel.style.display = 'none';
    triggerLabel.tabIndex = -1;
    triggerLabel.addEventListener('click', e => {
      e.stopPropagation();
    });

    const switchInput = document.createElement('input');
    switchInput.type = 'checkbox';
    switchInput.style.display = 'none';
    switchInput.tabIndex = -1;

    switchInput.setAttribute('switch', '');

    triggerLabel.appendChild(switchInput);

    document.body.appendChild(triggerLabel);
    triggerLabel.click();
    document.body.removeChild(triggerLabel);
  }
};
